<template>
  <div>
    <yd-table
      :loading="loading"
      :data="tableData"
      :pagination="pageState"
      @onChange="onTableChange"
      :settings="{ showIndex: true }"
    >
      <!-- <el-table-column align="center" type="index" label="序号" width="80" /> -->
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        align="center"
        :prop="item.filed"
        :label="item.title"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <template v-if="item.filed === 'linkRecordId'">
            <el-button :disabled="deleteLoading" type="text" @click="viewContent(scope.row)">
              查看详情
            </el-button>
            <el-button
              :loading="deleteLoading"
              type="text"
              @click="handleDelete(scope.row)"
              v-if="scope.row.channel === 1"
            >
              删除
            </el-button>
          </template>
          <span v-else>{{ scope.row[`${item.filed}`] }}</span>
        </template>
      </el-table-column>
      <template #statistics>
        <span>合计金额 {{ allMoney }} 元，当前页合计 {{ curPageMoney }} 元</span>
      </template>
    </yd-table>
  </div>
</template>

<script >
import { ref, inject, computed } from '@vue/composition-api';
import { tableColumns } from '../_data.js';
import { Message, MessageBox } from 'element-ui';
import { deleteImportSms } from '@/api/source/index.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const loading = inject('loading');
  const tableData = inject('tableData', []);
  const pageState = inject('pageState');
  const handleSizeChange = inject('handleSizeChange');
  const handleCurrentChange = inject('handleCurrentChange');
  const reset = inject('reset');
  const onTableChange = ({
    current,
    pageSize,
    type
  }) => {
    if (type === 'sizeChange') {
      handleSizeChange(pageSize);
    }
    if (type === 'currentChange' || type === 'fresh') {
      handleCurrentChange(current);
    }
  };

  // 查看内容
  const viewContent = inject('viewContent');
  // 金额合计
  const allMoney = inject('allMoney', 0);
  const curPageMoney = computed(() => {
    const _data = tableData.value.filter(item => item.price).map(item => {
      return parseFloat(item.price) * 1000;
    });
    const curPageSum = _data.reduce((a, b) => {
      return a + b;
    }, 0);
    return curPageSum / 1000;
  });

  // 删除导入数据
  const handleDelete = row => {
    MessageBox.confirm('是否确认删除该条营销短信记录?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteRecord(row);
    }).catch(() => {
      console.log('取消了');
    });
  };
  const deleteLoading = ref(false);
  const deleteRecord = async row => {
    deleteLoading.value = true;
    const res = await deleteImportSms(row.id);
    deleteLoading.value = false;
    const {
      code
    } = res || {};
    if (code !== 0) {
      return;
    }
    Message.success('删除成功');
    reset();
  };
  return {
    tableColumns,
    loading,
    tableData,
    pageState,
    onTableChange,
    viewContent,
    allMoney,
    curPageMoney,
    handleDelete,
    deleteLoading
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
